import Alpine from 'alpinejs';
import "../store/email-capture"
import AppAnalytics from '../analytics/AppAnalytics';

(window as typeof window & { Alpine: typeof Alpine }).Alpine = Alpine;

document.addEventListener('alpine:init', () => {

  Alpine.data('toltrazurilDosageCalculator', function() {
    return {
      weight: 0,
      weightUnit: 'kg',
      concentration: 5,
      ageGroup: 'puppy',
      purpose: 'treatment',
      result: null,

      calculate() {
        if (!this.weight || this.weight <= 0) {
          return;
        }

        this.$store.emailCap.cancel();


        // Convert weight to lb if needed
        let weightInLb = this.weightUnit === 'kg' ? this.weight * 2.20462 : this.weight;

        // Determine dosage rate based on age group and purpose
        let dosagePerLb = 0;
        if (this.ageGroup === 'puppy') {
          dosagePerLb = this.purpose === 'treatment' ? 15 : 5;
        } else {
          dosagePerLb = this.purpose === 'treatment' ? 20 : 10;
        }

        // Calculate total dosage in mg
        const dosageInMg = weightInLb * dosagePerLb;

        // Convert concentration percentage to mg/ml
        const concentrationInMgPerMl = (this.concentration / 100) * 1000;

        // Calculate final volume in ml
        this.result = (dosageInMg / concentrationInMgPerMl).toFixed(2);

        AppAnalytics.getPlausible()?.trackEvent('toltrazuril_dosage_result', {
          props: {
            result: this.result,
            ageGroup: this.ageGroup,
            weightInLb,
          }
        });

        if (this.result) this.$store.emailCap.onResult();
      }
    }

  })

});

Alpine.start();

